import endpoint from "@/libs/endPoint/ava/Respostas.endPoint";
import ApiServices from "@/services/uteis/ApiServices.js";

class RespostasServices {
  async porInstituicao(id_instituicao, id_questionario) {
    try {
      const url = endpoint.porInstituicao(id_instituicao, id_questionario);
      console.log(url);
      const { data } = await ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Erro ao buscar respostas por instituição:", error);
      throw error;
    }
  }
}
export default new RespostasServices();
